import * as React from "react";
import { AttachmentStore } from "Stores/attachmentStore";
import { inject, observer } from "mobx-react";
import { Row } from "react-bootstrap";
import {useParams} from "react-router";

export function AttachmentRedirectPage() {
    const { fileId } = useParams();
    return (
        <AttachmentRedirect fileId={fileId} />
    );
}


interface AttachmentRedirectProps {
    attachmentStore?: AttachmentStore
    fileId: string | undefined
}

@inject("attachmentStore")
@observer
export class AttachmentRedirect extends React.Component<AttachmentRedirectProps> {
    componentDidMount(){
        this.downloadAttachment();
    }

    downloadAttachment = () => {
        if (this.props.fileId) {
            this.props.attachmentStore!.downloadAttachment(this.props.fileId);
        }
    };

    render(){
        return (
            <Row className="justify-content-center text-center attachment-download">
                <div>
                    {"Your download will begin automatically in a few seconds. If it does not, "}
                    <a className="download-link" onClick={this.downloadAttachment}>click here</a>
                </div>
            </Row>
        );
    }
}

